import { memo } from 'react';

import { InfoIcon } from '@air/design-icons';
import { Tooltip } from '@air/primitive-tooltip';

export type ToggleInfoTooltipProps = {
  text: string;
  className?: string;
};

export const ToggleInfoTooltip = memo(({ text, className }: ToggleInfoTooltipProps) => (
  <Tooltip label={text} className={className}>
    <button type="button" aria-label={text} className="flex items-center">
      <InfoIcon size="sm" aria-hidden="true" className="ads:text-icon-default text-gray-10" />
    </button>
  </Tooltip>
));

ToggleInfoTooltip.displayName = 'ToggleInfoTooltip';
